import React, { useState, lazy } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
// import { funcFetchMasterData, funcFetchCityData, funcFetchBankListData, } from "../store/actions/MasterDataActions";
import Landing from "./Landing";
import { ComponentRoute } from "../shared/SharedUtility";
import { trackAdobeDncPages } from "../shared/AdobeUtility";
import { trackPages } from "../shared/utility";
import { Helmet } from "react-helmet";

const AvailCard = lazy(() => import(/* webpackChunkName: "AvailCard" */ "../components/AvailCard/AvailCard"));
const HappyToHelp = lazy(() => import(/* webpackChunkName: "HappyToHelp" */ "../components/HappyToHelp/HappyToHelp"));
const JourneyEnd = lazy(() => import(/* webpackChunkName: "JourneyEnd" */ "../components/JourneyEndSD2/JourneyEnd/JourneyEnd"));
const JourneyEndAll = lazy(() => import(/* webpackChunkName: "JourneyEndAll" */ "../components/JourneyEndAll/JourneyEndAll"));
const JourneyEndDataCapture = lazy(() => import(/* webpackChunkName: "JourneyEndAll" */ "../components/JourneyEndSD2/JourneyEndDataCapture/DataCapture"));
const KYCDetails = lazy(() => import(/* webpackChunkName: "KycDetails" */  "../components/Kyc/KYCDetails/KYCDetails"));
const MultiCard = lazy(() => import(/* webpackChunkName: "MultiCard" */ "../components/MultiCard/MultiCard"));
const ApplicationConscent = lazy(() => import(/* webpackChunkName: "MITCScreen" */ "../components/MitMidc/ApplicationConscent/ApplicationConscent"));
const CompleteApplication = lazy(() => import(/* webpackChunkName: "EcardGeneration" */ "../components/ECard/CompleteApplication/CompleteApplication"));
const ECard = lazy(() => import(/* webpackChunkName: "EcardScreen" */ "../components/ECard/ECardView/ECard"));
const CustomerEnhancement = lazy(() => import(/* webpackChunkName: "CustomerEnrichment" */ "../components/CustomerEnhancement/CustomerEnrichment"));
const UploadPanView = lazy(() => import(/* webpackChunkName: "UploadPan" */ "../components/UploadPan/UploadPanView"));
const SD1StatusCode101 = lazy(() => import(/* webpackChunkName: "SD1Status101" */ "../components/JourneyEndSD1/StatusCode101/StatusCode101"));
const PanDedupeExit = lazy(() => import(/* webpackChunkName: "Pandedupe" */ "../components/JourneyEndSD1/PanDedupeExit/PanDedupeExit"));
const WIP = lazy(() => import(/* webpackChunkName: "WIPScreen" */ "../components/MitMidc/WIP/WIPCase"));
const LienRetry = lazy(() => import(/* webpackChunkName: "LienRetryScreen" */ "../components/MitMidc/LienRetry/LienRetry"));
const Prefrences = lazy(() => import(/* webpackChunkName: "CardPrefrences" */ "../components/Prefrences/Prefrences"));
const Splash = lazy(() => import(/* webpackChunkName: "Splash" */ "../components/Splash/Splash"));
const HelpCenter = lazy(() => import(/* webpackChunkName: "HelpFAQ" */ "../components/HelpCenter/HelpCenter"));
const ChangeCard = lazy(() => import(/* webpackChunkName: "ChangeCard" */ "../components/ChangeCard/ChangeCard"));
const EapplyContinue = lazy(() => import(/* webpackChunkName: "KycDetails" */ "../components/EapplyContinue/EapplyContinue"));
const VkycMitc = lazy(() => import(/* webpackChunkName: "MitcReplica" */ "../components/VKYC/VkycMitc/VkycMitc"));
const VkycStatus = lazy(() => import(/* webpackChunkName: "VkycStatus" */ "../components/VKYC/VkycStatus/VkycStatus"));
const VkycRedirectionStatus = lazy(() => import(/* webpackChunkName: "VkycStatus" */ "../components/VKYC/VkycSTPN/VKycRedirectionStatus"));
const EkycWIP = lazy(() => import(/* webpackChunkName: "EKYC_WIP" */ "../components/Ekyc/WIP/EkycWIPCase"));
const VKYC_OFF_WIP = lazy(() => import(/* webpackChunkName: "VKYC_OFF_WIP" */ "../components/VKYC/WIP/VkycOffWIPCase"));
const WIPIndigo = lazy(() => import(/* webpackChunkName: "IndigoWIP" */ "../components/IndigoWIP/IndigoWip"));
const CorporateWip = lazy(()=> import(/* webpackChunkName: "VKYC_OFF_WIP" */ "../components/CorporateWip/CorporateWip"));
const CorporateEmpId = lazy(()=> import(/* webpackChunkName: "VKYC_OFF_WIP" */ "../components/CorporateEmpId/CorporateEmpId"));
const CorporateOtpView = lazy(()=> import(/* webpackChunkName: "VKYC_OFF_WIP" */ "../components/CorporateOtpView/CorporateOtp"));
const DigitalSecureWip = lazy(() => import(/* webpackChunkName: "DigitalSecureWIP" */ "../components/DigitalSecureWip/DigitalSecureWip"));

const MainRoutes = (props) => {
  const currentAppState = useSelector((state) => state.AppState);
 
  const { cardName } = useParams();
  const state = useSelector((state) => state.AppNav);
  
  const [isAdobeEvent, setisAdobeEvent] = useState(false);
  const dumpData = useSelector((state) => state.DumpData);

  let goTo = state && state.goTo ? state.goTo : "splash";
  goTo = props.isDumpBased && !dumpData ? "corporateEmpId" : goTo;

  // cardName can be used to call api

  const switchTabs = () => {
    if (!isAdobeEvent && !props.isTrackRet && !props.isDumpBased) {
      trackPages("tracking_4");
      trackAdobeDncPages("help", currentAppState, "pageView", "", "");
      setisAdobeEvent(true);
    }
    switch (goTo) {
      case "splash":
        return ComponentRoute(Splash, cardName);
      case "help":
        return ComponentRoute(HappyToHelp, cardName);
      case "kycDetails":
        return ComponentRoute(KYCDetails, cardName);
      case "multiCard":
        return ComponentRoute(MultiCard, cardName, true);
      case "availCard":
        return ComponentRoute(AvailCard, cardName, true);
      case "changecard":
        return ComponentRoute(ChangeCard, cardName);
      case "journeyEnd":
        return ComponentRoute(JourneyEnd, cardName);
      case "journeyEndAll":
        return ComponentRoute(JourneyEndAll, cardName);
      case "sd2DataCapture":
        return ComponentRoute(JourneyEndDataCapture, cardName);
      case "sd1Statu101":
        return ComponentRoute(SD1StatusCode101, cardName);
      case "panDedupeExit":
        return ComponentRoute(PanDedupeExit, cardName);
      case "applicationConscent":
        return ComponentRoute(ApplicationConscent, cardName);
      case "completeApplication":
        return ComponentRoute(CompleteApplication, cardName);
      case "eCard":
        return ComponentRoute(ECard, cardName);
      case "customerEnhancement":
        return ComponentRoute(CustomerEnhancement, cardName);
      case "helpcenter":
        return ComponentRoute(HelpCenter, cardName);
      case "uploadPanView":
        return ComponentRoute(UploadPanView, cardName);
      case "wip":
        return ComponentRoute(WIP, cardName);
      case "lienRetry":
        return ComponentRoute(LienRetry, cardName);
      case "preferences":
        return ComponentRoute(Prefrences, cardName);
      case "EapplyContinue":
        return ComponentRoute(EapplyContinue, cardName);
      case "VkycMitc":
          return ComponentRoute(VkycMitc, cardName);
      case "VkycStatus":
          return ComponentRoute(VkycStatus, cardName);
      case "VkycRedirectionStatus":
          return ComponentRoute(VkycRedirectionStatus, cardName);
      case "conditionalMITC":
           return ComponentRoute(ApplicationConscent, cardName);
      case "STPNStatus":
          return ComponentRoute(JourneyEndDataCapture, cardName);
      case "EKYC_WIP":
          return ComponentRoute(EkycWIP, cardName);    
      case "VkycOffWip":
          return ComponentRoute(VKYC_OFF_WIP, cardName);
      case "WIPIndigo":
          return ComponentRoute(WIPIndigo, cardName);
      case "corporateWip":
          return ComponentRoute(CorporateWip , cardName); 
      case "corporateEmpId":
        return ComponentRoute(CorporateEmpId , cardName);
      case "corporateOtpView":
        return ComponentRoute(CorporateOtpView , cardName);
      case "digitalSecureWip":
          return ComponentRoute(DigitalSecureWip , cardName);
      default:
        return <Landing />;
    }
  };
  return <>
    <Helmet>
      <title>{currentAppState?.cardListDetails?.title}</title>
      <meta name='description' content={currentAppState?.cardListDetails?.description} />
      <meta name="keywords" content={currentAppState?.cardListDetails?.keywords} />
    </Helmet>
    {switchTabs()}
  </>;
};

export default MainRoutes;
